import Card from "@pathwright/ui/src/components/card/Card"
import { ConnectStores } from "lib/core/store"
import CategoryFormContainer from "./CategoryFormContainer"

const CategoryFormCard = ({ card, title, existingCategory, initialName }) => (
  <Card title={title} card={card}>
    <CategoryFormContainer
      closeCard={card.onClose}
      initialName={initialName}
      onDirty={() => {
        if (existingCategory) {
          return card.setCardDirty(true)
        }
      }}
      onPristine={() => {
        if (existingCategory) {
          return card.setCardDirty(false)
        }
      }}
    />
  </Card>
)

CategoryFormCard.displayName = "CategoryFormCard"

const mapStateToProps = function (state, ownProps) {
  const { category } = state.categoryAdminStore.state

  const existingCategory = category != null ? category.id : undefined
  const title = existingCategory
    ? category.name
    : category
    ? "New Category"
    : ""

  const initialName =
    typeof ownProps.location?.query?.name === "string"
      ? ownProps.location.query.name.trim()
      : ""

  return _.assign(
    {},
    {
      title,
      existingCategory,
      initialName
    },
    ownProps
  )
}

const stores = [{ store: "categoryAdmin", watch: ["category"] }]

export default ConnectStores(CategoryFormCard, stores, {}, mapStateToProps)
